import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-breadcurmbs',
  templateUrl: './breadcurmbs.component.html',
  styleUrls: ['./breadcurmbs.component.scss'],
  standalone: true,
  imports: [NgFor, NgIf, RouterLink, AngularSvgIconModule],
})
export class BreadcurmbsComponent implements OnInit {
  @Input() breadcrumbItems: any[] = [];

  constructor() {}

  ngOnInit(): void {}
}
